/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Parts_IncludedInputs */

const en_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts Included?`)
};

const es_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Piezas incluidas?`)
};

const fr_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces incluses ?`)
};

const de_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile inklusive?`)
};

const ja_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーツが全て揃っているか`)
};

const zh_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含零件？`)
};

const ar_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل الأجزاء متضمنة؟`)
};

const id_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suku Cadang Termasuk?`)
};

const it_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pezzi Inclusi?`)
};

const ru_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали в комплекте?`)
};

const pt_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peças Incluídas?`)
};

const ko_field_parts_included = /** @type {(inputs: Field_Parts_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부품 포함 여부`)
};

/**
* | output |
* | --- |
* | "Parts Included?" |
*
* @param {Field_Parts_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_parts_included = /** @type {((inputs?: Field_Parts_IncludedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Parts_IncludedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_parts_included(inputs)
	if (locale === "es") return es_field_parts_included(inputs)
	if (locale === "fr") return fr_field_parts_included(inputs)
	if (locale === "de") return de_field_parts_included(inputs)
	if (locale === "ja") return ja_field_parts_included(inputs)
	if (locale === "zh") return zh_field_parts_included(inputs)
	if (locale === "ar") return ar_field_parts_included(inputs)
	if (locale === "id") return id_field_parts_included(inputs)
	if (locale === "it") return it_field_parts_included(inputs)
	if (locale === "ru") return ru_field_parts_included(inputs)
	if (locale === "pt") return pt_field_parts_included(inputs)
	return ko_field_parts_included(inputs)
});